import React from 'react';
import { KPICard } from '../../types/dashboard.types';

const statusColors = {
  positive: 'text-green-600',
  negative: 'text-red-600',
  neutral: 'text-gray-500',
};

const bgColors = {
  positive: 'bg-green-50',
  negative: 'bg-red-50',
  neutral: 'bg-gray-50',
};

const MetricCard: React.FC<KPICard> = ({ title, value, icon, trend, status }) => {
  return (
    <div className={`rounded-xl shadow-sm p-6 flex flex-col gap-2 ${bgColors[status]} min-w-[200px]`}>
      <div className="flex items-center gap-3 mb-2">
        <div className="w-10 h-10 flex items-center justify-center rounded-lg bg-white shadow">
          {icon}
        </div>
        <span className="text-base font-semibold text-gray-700">{title}</span>
      </div>
      <div className="flex items-end gap-2">
        <span className="text-3xl font-bold text-gray-900">{value}</span>
        {trend && (
          <span className={`text-sm font-medium ${trend.value >= 0 ? 'text-green-600' : 'text-red-600'}`}>{trend.value > 0 ? '+' : ''}{trend.value}%</span>
        )}
      </div>
    </div>
  );
};

export default MetricCard; 